
import Vue from 'vue'

import SelectPlan from '@/views/account/SelectPlan.vue'
import { RButton } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import UpdateCard from '@/components/account/UpdateCard.vue'
import PlanDetails from '@/components/account/PlanDetails.vue'
import RedeemCodeInput from '@/components/account/RedeemCodeInput.vue'
import { getAppRootURL } from '@/config'

export default Vue.extend({
  name: 'NoCredits',
  head: {
    link: [{ rel: 'canonical', href: `${getAppRootURL()}/no-credits/`, id: 'canonical' }],
  },
  components: {
    RButton,
    SelectPlan,
    UpdateCard,
    PlanDetails,
    RedeemCodeInput,
  },
  methods: {
    async onCancelSubscription() {
      await this.cancelSubscription()
      this.$rModal.hide('confirmSubscriptionCancelModal')
      this.$rModal.show('cancelSubscriptionSuccess')
    },
    ...mapActions({
      logOut: 'user/logOut',
      cancelSubscription: 'user/cancelSubscription',
    }),
  },
  computed: {
    ...mapGetters({
      loggedIn: 'user/loggedIn',
      getBundleRequestPending: 'config/getConfigRequestPending',

      user: 'user/user',
      hasPaymentMethod: 'user/hasPaymentMethod',
      subscriptionCancelRequest: 'user/subscriptionCancelRequest',
      storagePlan: 'user/storagePlan',
      selectedTier: 'user/selectedTier',
    }),
  },
})
